/**
 * Full-screen fill dialogs (GridFillDialog, CrossFillDialog) extend under the status bar
 * in Capacitor iOS/Android WebViews with viewport-fit=cover. Mobile Safari/Chrome in the
 * browser usually reports 0 safe-area insets, so layout stays unchanged there.
 */

/** DialogTitle: keeps type / title / tags below the notch or status bar. */
export const fillDialogTitleSx = {
    display: "block",
    position: "relative",
    pt: { xs: "calc(8px + env(safe-area-inset-top, 0px))", sm: 2 },
    px: { xs: 1, sm: 2 },
    pb: { xs: 0.5, sm: 1 },
    pr: { xs: 6, sm: 2 },
};

/** Absolute close control: same vertical offset as title padding; respects right inset (notch). */
export const fillDialogCloseIconButtonSx = {
    position: "absolute",
    right: { xs: "calc(8px + env(safe-area-inset-right, 0px))", sm: 8 },
    top: { xs: "calc(8px + env(safe-area-inset-top, 0px))", sm: 12 },
    color: "text.secondary",
};
